type JsonBody = Record<string, unknown> | unknown[] | string | null

export async function apiFetch<T>(
  path: string,
  init?: RequestInit & {
    json?: JsonBody | undefined
    form?: FormData | undefined
  },
): Promise<T> {
  const headers = new Headers(init?.headers ?? {})

  let body = init?.body

  if (init?.form) {
    body = init.form

    headers.delete('content-type')
  } else if (init?.json !== undefined) {
    headers.set('content-type', 'application/json')
    body = typeof init.json === 'string' ? init.json : JSON.stringify(init.json)
  }

  const res = await fetch(path, {
    ...init,
    headers,
    body,
    credentials: 'include',
    cache: 'no-store',
  })

  let payload: unknown = null

  try {
    payload = await res.json()
  } catch {
    payload = null
  }

  if (!res.ok) {
    const err = new Error(typeof (payload as { error?: { message?: string } })?.error?.message === 'string'
      ? (payload as { error: { message: string } }).error.message
      : `Request failed (${res.status})`) as Error & { status?: number; payload?: unknown }

    err.status = res.status
    err.payload = payload
    throw err
  }

  return payload as T
}
